<script setup>
import debounce from 'lodash.debounce';
import { onMounted, onUnmounted, ref } from 'vue';

defineProps({
  target: {
    type: String,
    required: true,
    default: '',
  },
  title: {
    type: String,
    required: false,
    default: '',
  },
  usePadding: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const canvasWidth = ref('');
const desktopMode = ref('');

onMounted(() => {
  resizeHandler();
  window.addEventListener('resize', resizeHandler);
});

onUnmounted(() => {
  window.removeEventListener('resize', resizeHandler);
});

const resizeHandler = debounce(() => {
  const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  desktopMode.value = width > 992;
  if (desktopMode.value) {
    canvasWidth.value = '50%';
  } else {
    canvasWidth.value = '100%';
  }
}, 50);
</script>

<template>
  <div
    :id="target"
    class="offcanvas offcanvas-bottom rounded-top"
    :class="{
      'offcanvas-bottom': !desktopMode,
      'offcanvas-start': desktopMode,
      'p-4': usePadding,
    }"
    :style="{ height: 'auto', width: `${canvasWidth}`, overflowY: 'auto' }"
    tabindex="-1"
    aria-labelledby="offcanvasBottomLabel"
  >
    <div
      class="top-click d-flex align-items-center justify-content-center"
      data-bs-dismiss="offcanvas"
    >
      <span
        class="close"
        aria-label="close"
      />
    </div>
    <div class="offcanvas-header">
      <h4
        id="offcanvasBottomLabel"
        class="offcanvas-title"
      >
        {{ title }}
      </h4>
    </div>
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.top-click {
  cursor: pointer;
}

.close {
  width: 20px;
  height: 20px;
  background: url('@/assets/svg/icons/chevron-left.svg') no-repeat left center;
  transform: rotate(-90deg);

  &:hover {
    cursor: pointer;
  }
}
</style>
